export default {
	form: [{
			title: '基本信息',
			label: '',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: '',
			type: 'title',
		}, {
			label: '实施时间',
			field: 'implement_period',
			type: '',
			disabled:true
		}, {
			label: '项目名称',
			field: 'name',
			disabled:true
		}, {
			label: '团队名称',
			field: 'team_name',
			isHide:true,
			disabled:true
		},
		{
			label: '参赛组别',
			field: 'group_id',
			type: 'select',
			rangLabel: 'label',
			rangValue: 'value',
			detailField: 'group',
			actionOption: 'group',
			disabled:true
		}, {
			label: '成果类型',
			field: 'achievement_id',
			type: 'select',
			rangLabel: 'label',
			rangValue: 'value',
			dataType: 'array',
			detailField: 'achievement',
			actionOption: 'achievement',
			disabled:true
			// option: [{
			// 	label: '高校学分认定课',
			// 	value: 1
			// }, {
			// 	label: '社会学习者课程',
			// 	value: 2
			// }]
		}, {
			label: '实践形式',
			field: 'practice_id',
			type: 'select',
			rangLabel: 'label',
			rangValue: 'value',
			dataType: 'array',
			detailField: 'practice',
			actionOption: 'practice',
			disabled:true
			// option: [{
			// 	label: '高校学分认定课',
			// 	value: 1
			// }, {
			// 	label: '社会学习者课程',
			// 	value: 2
			// }]
		}, {
			title: '项目介绍',
			label: '',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: '',
			type: 'title',
		}, {
			label: '简介',
			field: 'desc',
			type: 'textarea',
			width: '100%',
			conWidth: 'calc(66.6666% - 10px)',
			rows: 6,
			disabled:true
		}, {
			title: '指导教师信息',
			label: '',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: '',
			type: 'title',
		}, {
			label: '',
			tips: '',
			tips: '每支参赛团队由1-3名指导教师组成,每位指导教师至多指导2支参赛团队',
			type: 'table',
			width: "100%",
			max: 3,
			field: 'teacher',
			addText: '添加教师信息',
			disabled:true,
			column: [{
				type: 'index'
			}, {
				type: 'move'
			}, {
				type: 'input',
				label: '教师姓名',
				prop: 'name',
				required:true,
				width: 140,
				placeholderArray: ['第一指导教师'],
				isHide:true
			}, {
				type: 'input',
				label: '职务/职称',
				prop: 'position',
				width: 160
			}, {
				type: 'input',
				label: '研究方向',
				prop: 'direction',
				width: 160
			}, {
				type: 'input',
				label: '联系方式',
				prop: 'phone',
				inputType: 'number',
				maxlength: 11,
				width: 160,
				required:true,
				isHide:true
			}, {
				type: 'input',
				label: '指导教师简介',
				prop: 'desc',
			}]
		}, {
			title: '团队信息',
			label: '',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: '',
			type: 'title',
		}, {
			label: '是否是跨校组队',
			field: 'is_cross_school',
			type: 'radio',
			rangLabel: 'label',
			rangValue: 'value',
			actionOption: 'is_cross_school',
			detailField: 'is_cross',
			disabled:true,
			option: [{
				label: '是',
				value: 1
			}, {
				label: '否',
				value: 2
			}]
		}, {
			label: '参赛诚信承诺书',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: 'integrity_files',
			limit: 100,
			title: '',
			type: 'upload-independent',
			text: '点击上传參赛诚信承诺书',
			tips: '支持pdf,png,jpg格式，文件大小不超过50m',
			tipslink:'參赛诚信承诺书模板下载',
			linkUrl:'https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fuccres.fltrp.com%2Fsdxwk%2Fdownload%2F%25E5%258F%2582%25E8%25B5%259B%25E8%25AF%259A%25E4%25BF%25A1%25E6%2589%25BF%25E8%25AF%25BA%25E4%25B9%25A6.docx%3Fv3&wdOrigin=BROWSELINK',
			accept: '.png,.jpg,.jpeg,.webp,.pdf,.doc,.docx',
			isHide:true,
			disabled:true
		},
		{
			title: '团队负责人',
			label: '',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: '',
			type: 'title',
		},
		{
			tips: '每支参赛团队由3-15名学生组成，其中团队负责人1名（须为本科生）。研究生人数不超过团队成员数量的30%。每人限负责一个团队，但可同时作为团队成员参与其他团队报名',
			label: '',
			width: '100%',
			style: {
				marginBottom: '-20px',
				marginTop: '-20px',
				color: 'red'
			},
			field: '',
			type: 'tips',
		},
		{
			type: 'input',
			label: '负责人姓名',
			field: 'team_principal-name',
			isHide:true,
			disabled:true
		},
		{
			type: 'input',
			label: '负责人手机号',
			field: 'team_principal-phone',
			inputType: 'number',
			maxlength: 11,
			isHide:true,
			disabled:true
		}, {
			label: '负责人学历',
			field: 'team_principal-education',
			type: 'select',
			rangLabel: 'name',
			rangValue: 'id',
			dataType: 'array',
			detailField: 'education',
			actionOption: 'education',
			disabled:true
			// option: [{
			// 	label: '高校学分认定课',
			// 	value: 1
			// }, {
			// 	label: '社会学习者课程',
			// 	value: 2
			// }]
		}, {
			label: '负责人学校',
			field: 'team_principal-school_name',
			type: 'select-school',
			detailField: 'team_principal-school_name',
			rangValue:'name',
			option: [],
			isHide:true,
			disabled:true
		}, {
			type: 'input',
			label: '负责人学院',
			field: 'team_principal-academy',
			disabled:true
		}, {
			type: 'input',
			label: '负责人专业',
			field: 'team_principal-profession',
			disabled:true
		}, {
			label: '负责人简介',
			field: 'team_principal-desc',
			type: 'textarea',
			width: '100%',
			conWidth: 'calc(66.6666% - 10px)',
			rows: 6,
			disabled:true
		}, {
			label: '团队成员',
			tips: '',
			type: 'table',
			width: "100%",
			field: 'team',
			max: 14,
			disabled:true,
			column: [{
					type: 'index'
				}, {
					type: 'move'
				}, {
					type: 'input',
					label: '姓名',
					prop: 'name',
					width: 100,
					required:true,
					isHide:true
				},
				{
					type: 'input',
					label: '手机号',
					prop: 'phone',
					inputType: 'number',
					maxlength: 11,
					required:true,
					isHide:true
				}, {
					label: '学历',
					prop: 'education',
					type: 'select',
					rangLabel: 'name',
					rangValue: 'id',
					dataType: 'array',
					detailField: 'education',
					actionOption: 'education',
					width: 140,
					required:true,
					// option: [{
					// 	label: '高校学分认定课',
					// 	value: 1
					// }, {
					// 	label: '社会学习者课程',
					// 	value: 2
					// }]
				}, {
					label: '学校',
					prop: 'school_name',
					type: 'select-school',
					option: [],
					required:true,
					isHide:true
				}, {
					type: 'input',
					label: '学院',
					prop: 'academy',
					required:true,
				}, {
					type: 'input',
					label: '专业',
					prop: 'profession',
					required:true,
				}, {
					type: 'input',
					label: '任务分工',
					prop: 'desc',
					width: 220
				}
			]
		},
		{
			label: '完整版实践创新报告提交',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: 'innovation_files',
			limit: 100,
			title: '',
			tTips: '上传实践创新报告完整版(含学校，指导教师及学生团队信息”)',
			type: 'upload-independent',
			text: '上传实践创新报告',
			tips: '只能上传 Pdf / Word 文件',
			accept: '.pdf,.doc,.docx',
			showType:1
		},
		{
			label: '活页版实践创新报告提交',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: 'leaflet_innovation_files',
			limit: 100,
			title: '',
			tTips: '上传实践创新报告盲评活页版(请隐藏学校，指导教师及学生团队信息全部信息后上传)',
			type: 'upload-independent',
			text: '上传实践创新报告',
			tips: '只能上传 Pdf / Word 文件',
			accept: '.pdf,.doc,.docx',
			showType:2
		},
		{
			label: '完整版项目PPT提交',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			tTips:'上传项目PPT完整版(含学校，指导教师及学生团队信息)',
			field: 'project_files',
			limit: 100,
			title: '',
			text: '上传项目PPT',
			type: 'upload-independent',
			tips: '只能上传 ppt / pptx文件',
			accept: '.ppt,.pptx',
			showType:1
		},
		{
			label: '活页版项目PPT提交',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			tTips:'上传项目PPT盲评活页版(请隐藏学校，指导教师及学生团队信息全部信息后上传)',
			field: 'leaflet_project_files',
			limit: 100,
			title: '',
			text: '上传项目PPT',
			type: 'upload-independent',
			tips: '只能上传 ppt / pptx文件',
			accept: '.ppt,.pptx',
			showType:2
		},
		{
			label: '完整版其他支撑材料',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: 'other_files',
			limit: 6,
			title: '',
			tTips: '上传其他支撑材料完整版(含学校，指导教师及学生团队信息)，支持文件材料个数不超过6个',
			type: 'upload-independent',
			text: '上传其他支撑材料',
			tips: '只能上传 Pdf / Word文件',
			accept: '.pdf,.doc,.docx',
			showType:1
		},
		{
			label: '活页版其他支撑材料',
			width: '100%',
			style: {
				marginBottom: '0',
				marginLeft: '-10px'
			},
			field: 'leaflet_other_files',
			limit: 6,
			title: '',
			tTips: '上传其他支撑材料盲评活页版(请隐藏学校，指导教师及学生团队信息全部信息后上传)，支持文件材料个数不超过6个',
			type: 'upload-independent',
			text: '上传其他支撑材料',
			tips: '只能上传 Pdf / Word 文件',
			accept: '.pdf,.doc,.docx',
			showType:2
		},
	],
	rules: {
		name: [{
			required: true,
			message: '请输入项目名称',
			trigger: 'blur'
		}],
		achievement_id: [{
			required: true,
			message: '请选择成功类型',
			trigger: 'change'
		}],
		group_id: [{
			required: true,
			message: '请选择参赛组别',
			trigger: 'change'
		}],
		is_cross_school: [{
			required: true,
			message: '请选择是否跨校组队',
			trigger: 'change'
		}],
		'team_principal-name': [{
			required: true,
			message: '请填写团队负责人姓名',
			trigger: 'blur'
		}],
		'team_principal-phone': [{
			required: true,
			message: '请填写团队负责人手机号',
			trigger: 'blur'
		}],
		'team_principal-education': [{
			required: true,
			message: '请填写团队负责人学历',
			trigger: 'blur'
		}],
		'team_principal-school_name': [{
			required: true,
			message: '请选择团队负责人学校',
			trigger: 'blur'
		}],
		'team_principal-academy': [{
			required: true,
			message: '请填写团队负责人学院',
			trigger: 'blur'
		}],
		'team_principal-profession': [{
			required: true,
			message: '请填写团队负责人专业',
			trigger: 'blur'
		}],
		innovation_files: [{
			required: true,
			message: '请上传完整版实践创新报告',
			trigger: 'change'
		}],
		project_files: [{
			required: true,
			message: '请上传完整版参赛PPT',
			trigger: 'change'
		}],
		// leaflet_innovation_files: [{
		// 	required: true,
		// 	message: '请上传活页版实践创新报告',
		// 	trigger: 'change'
		// }],
		// leaflet_project_files: [{
		// 	required: true,
		// 	message: '请上传活页版参赛PPT',
		// 	trigger: 'change'
		// }],
	}
}